import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { LoadData } from '../models/LoadData';
import { TicketMaintenanceService } from 'src/app/services/ticket-maintenance.service';
import { ScheduleDataService } from 'src/app/services/schedule-data.service';
import { Load } from 'src/app/models/Load';
import { DeleteParameters } from 'src/app/models/DeleteParameters';
import { FormStatus, LoadBankType } from 'src/app/models/Enums';
import { LoadBankApplyParameters } from 'src/app/models/LoadBankApplyParameters';
import { SearchParamsModel } from '../models/search-params-model';
import { StorageService } from '../services/storage.service';

@Component({
    selector: 'app-load-list',
    templateUrl: 'load-list.component.html',
    styleUrls: ['load-list.component.css'],
    standalone: false
})
export class LoadListComponent {
  @Input() loads: LoadData[] = [];
  @Output() deleteComplete = new EventEmitter<number>();
  @Output() loadBankApplyParametersEmit = new EventEmitter<LoadBankApplyParameters>();
  @Output() loadListEmit = new EventEmitter<number>();
  @Output() closePopupEmit = new EventEmitter<boolean>();

  @ViewChild('tableContainer') tableContainer!: ElementRef;

  loadsData: LoadData[] = [];
  errorMessage: string = '';
  deleteConfirmFormId: string = 'loadDeleteModal';
  deleteItemParams: DeleteParameters;
  showDelete: boolean = false;
  showForm: boolean = true;
  showLoadBankApplyForm: boolean = false;
  selectedLoadData: LoadData;
  formStatus: FormStatus = FormStatus.Normal;
  selectAll: boolean = false;
  loadBankApplyFormId: string = 'loadBankApplyModal';
  loadBankApplyParameters: LoadBankApplyParameters = new LoadBankApplyParameters();
  loadBankApplyFormIdSc: string = '';
  FormStatus = FormStatus;
  constructor(
    private _scheduleDataService: ScheduleDataService,
    private _storageService: StorageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.resetLoadBankApplyParameters();

    if (changes['loads']) {
      this.resetTableScroll(); 
      this.initializeLoadsData();
      this.resetViewStates();
    }
  }

  private resetLoadBankApplyParameters(): void {
    this.loadBankApplyParameters = new LoadBankApplyParameters();
    this.loadBankApplyParameters.contractIds = [];
  }

  private resetTableScroll(): void {
    const container = this.tableContainer?.nativeElement;
    if (container) {
      container.scrollTop = 0;
      container.scrollLeft = 0;
    }
  }

  private initializeLoadsData(): void {
    this.loadsData = this.loads?.map(row => ({
      ...row,
      isSelected: false
    }));
  }

  private resetViewStates(): void {
    this.showDelete = false;
    this.showForm = true;
    this.showLoadBankApplyForm = false;
  }

  getDay(pickupDate: string): string {
    const date = new Date(pickupDate);
    return date.toLocaleString('en-US', { weekday: 'short' });
  }

  updateLoad(loadData: LoadData): void {
    this._scheduleDataService.saveLoadForMobile(loadData).subscribe({
      error: err => (this.errorMessage = err)
    });
  }

  deleteLoadConfirmation(loadData: LoadData): void {
    this.showDelete = true;
    this.showForm = false;
    this.showLoadBankApplyForm = false;
    this.selectedLoadData = loadData;
  }

  deleteLoad(): void {
    this.formStatus = FormStatus.Deleting;
    this._scheduleDataService.deleteLoad(this.selectedLoadData.loadId).subscribe({
      next: () => {
        this.onDeleteSuccess();
      },
      error: err => (this.errorMessage = err)
    });
  }

  private onDeleteSuccess(): void {
    this.loadsData = this.loadsData.filter(c => c.loadId !== this.selectedLoadData.loadId);
    this.deleteComplete.emit(this.selectedLoadData.dispatchId);
    this.resetViewStates();
    this.formStatus = FormStatus.Normal;
  }

  toggleSelectAll(): void {
    this.loadsData.forEach(row => (row.isSelected = this.selectAll));
  }

  checkSelectAll(): void {
    this.selectAll = this.loadsData.every(row => row.isSelected);
  }

  openLoadBank(dispatchId: number, loadId: number, loadBankType: LoadBankType): void {
    this.showDelete = false;
    this.showForm = false;
    this.showLoadBankApplyForm = true;

    const storedDataFromLS = this._storageService.getData<SearchParamsModel>('advancedSearchFormParams');
    const selectedLoadIds = this.getSelectedLoadIds(loadId);

    let parameters = new LoadBankApplyParameters();
    parameters.locCode = storedDataFromLS.locCode;
    parameters.dispatchId = dispatchId;
    parameters.contractIds = [];
    parameters.parentModal = "loadsModal";
    parameters.loadBankType = loadBankType;
    parameters.loadIds = selectedLoadIds; 
    this.loadBankApplyParameters = parameters;
    this.loadBankApplyFormIdSc = "loadBankApplyModal";
  }

  private getSelectedLoadIds(loadId: number): number[] {
    const selectedLoadIds = this.loadsData
      .filter(row => row.isSelected)
      .map(row => row.loadId);

    return selectedLoadIds.length > 0 ? selectedLoadIds : [loadId];
  }

  loadBankApplyComplete(dispatchId: number): void {
    this.loadsData = [...this.loads];
    this.resetViewStates();
    this.resetLoadBankApplyParameters();
    this.selectAll = false;
    this.loadListEmit.emit(dispatchId);
    this.cdr.detectChanges();
  }

  closePopup(): void {
    this.resetViewStates();
    this.selectAll = false;
    this.closePopupEmit.emit(true);
  }
}
